import { injectable, inject } from 'inversify';
import Debug from 'debug';
import * as Commands from './commands'
import { DualCommandQueue }from '../../shared/dual-command-queue'

const debug = Debug('question-attempt-service')

export const QuestionAttemptServiceSymbol = Symbol.for('QuestionAttemptService')

@injectable()
export class QuestionAttemptService {

  private queue: DualCommandQueue;

  constructor(
    @inject(Commands.AddQuestionAttemptCommandHandler)
    private addQuestionAttemptsCommand: Commands.AddQuestionAttemptCommandHandler,
    @inject(Commands.QueryQuestionAttemptsTrackingStateCommandHandler)
    private queryTrackingStateCommand: Commands.QueryQuestionAttemptsTrackingStateCommandHandler) {

    this.queue = new DualCommandQueue('question-attempt-service')
  }

  public start() {
    debug('starting QuestionAttemptService');

    this.queue.start();
    this.queue.enqueueRemote('query-tracking-state', () => this.queryTrackingStateCommand.execute());
  }

  public async stop() {
    debug('stopping QuestionAttemptService');

    await this.queue.stop()
  }

  public addQuestionAttempts(payload: Commands.AddQuestionAttemptCommandPayload) {
    debug('addQuestionAttempts', payload)
    
    this.queue.enqueueLocal('add-question-attempts', async () => {
      this.addQuestionAttemptsCommand.execute(payload)
    })
  }

}
